"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Checkbox_meta_1 = require("../Checkbox.meta");

var Image_1 = __importDefault(require("../../Image/Image"));

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent(Image_1.default, Checkbox_meta_1.CHECKBOX_CATEGORY_KEY, Checkbox_meta_1.CHECKBOX_COMPONENT_KEY, ['icon']);